import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { track } from "../lib/analytics";

export default function UsageTracker() {
  const location = useLocation();
  const lastSearch = useRef("");
  const searchTimer = useRef(null);

  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return;
    track("page_view", {}, location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    const q = new URLSearchParams(location.search).get("q") || "";
    if (!q || q === lastSearch.current) return;
    clearTimeout(searchTimer.current);
    searchTimer.current = setTimeout(() => {
      lastSearch.current = q;
      track("search", { q }, location.pathname);
    }, 1200);
    return () => clearTimeout(searchTimer.current);
  }, [location.search, location.pathname]);

  return null;
}
